'use client';

import { useSelectionStore } from './private/use-selection-store';

/**
 * Selected cross-sell add-on products.
 */
export function useAdditionalProducts() {
  const { additionalProducts, setAdditionalProducts } = useSelectionStore();

  return { additionalProducts, setAdditionalProducts };
}
